// extracted by mini-css-extract-plugin
module.exports = {"styledModal":"Fy8xkAVt","content":"a0EGvNVe","sources":"_6FVcubG","resetDescription":"Zktrkaqj"};